"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPreviousDateRange = exports.defaultDateRange = void 0;
const date_fns_1 = require("date-fns");
const defaultDateRange = () => {
    const dateRange = [
        (0, date_fns_1.format)((0, date_fns_1.subDays)(new Date(), 31), 'yyyy-MM-dd'),
        (0, date_fns_1.format)((0, date_fns_1.subDays)(new Date(), 1), 'yyyy-MM-dd'),
    ];
    return dateRange;
};
exports.defaultDateRange = defaultDateRange;
const defaultPreviousDateRange = () => {
    const dateRange = [
        (0, date_fns_1.format)((0, date_fns_1.subDays)(new Date(), 62), 'yyyy-MM-dd'),
        (0, date_fns_1.format)((0, date_fns_1.subDays)(new Date(), 32), 'yyyy-MM-dd'),
    ];
    return dateRange;
};
exports.defaultPreviousDateRange = defaultPreviousDateRange;
//# sourceMappingURL=defaultDateRange.js.map